import { Briefcase, Check, X } from "lucide-react";

export const VendorsTab = ({ vendors, vendorFilter, setVendorFilter, onVerify, onReject }) => (
  <div>
    <div className="flex items-center gap-2 mb-4">
      <select
        value={vendorFilter}
        onChange={(e) => setVendorFilter(e.target.value)}
        className="input-minimal w-auto"
        data-testid="vendor-filter"
      >
        <option value="pending">Pending</option>
        <option value="verified">Verified</option>
        <option value="all">All</option>
      </select>
    </div>

    <div className="space-y-3">
      {vendors.length === 0 ? (
        <div className="glass-card p-8 text-center">
          <Briefcase className="w-12 h-12 text-[#3F3F46] mx-auto mb-3" />
          <p className="text-[#A1A1AA]">No vendors found</p>
        </div>
      ) : (
        vendors.map((vendor) => (
          <div
            key={vendor.provider_id}
            className="glass-card p-4"
            data-testid={`admin-vendor-${vendor.provider_id}`}
          >
            <div className="flex items-start justify-between">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h4 className="text-[#EDEDED] font-medium">{vendor.display_name}</h4>
                  {vendor.is_verified ? (
                    <span className="px-2 py-0.5 bg-[#22C55E]/10 text-[#22C55E] text-xs rounded-full">
                      Verified
                    </span>
                  ) : (
                    <span className="px-2 py-0.5 bg-[#F59E0B]/10 text-[#F59E0B] text-xs rounded-full">
                      Pending
                    </span>
                  )}
                </div>
                <p className="text-sm text-[#71717A]">
                  {vendor.user_name} ({vendor.user_email})
                </p>
                <div className="flex flex-wrap gap-2 mt-2 text-sm text-[#A1A1AA]">
                  <span className="capitalize">{vendor.service_type}</span>
                  <span className="text-[#3F3F46]">|</span>
                  <span className="capitalize">{vendor.species}</span>
                  {(vendor.location_city || vendor.location_state) && (
                    <>
                      <span className="text-[#3F3F46]">|</span>
                      <span>
                        {[vendor.location_city, vendor.location_state].filter(Boolean).join(", ")}
                      </span>
                    </>
                  )}
                </div>
                {vendor.description && (
                  <p className="text-xs text-[#52525B] mt-2 line-clamp-2">{vendor.description}</p>
                )}
              </div>
              {!vendor.is_verified && (
                <div className="flex gap-2 ml-4">
                  <button
                    onClick={() => onVerify(vendor.provider_id)}
                    className="p-2 rounded-lg bg-[#22C55E]/10 text-[#22C55E] hover:bg-[#22C55E]/20 transition-colors"
                    title="Verify"
                    data-testid={`verify-vendor-${vendor.provider_id}`}
                  >
                    <Check className="w-4 h-4" />
                  </button>
                  <button
                    onClick={() => onReject(vendor.provider_id)}
                    className="p-2 rounded-lg bg-[#EF4444]/10 text-[#EF4444] hover:bg-[#EF4444]/20 transition-colors"
                    title="Reject"
                    data-testid={`reject-vendor-${vendor.provider_id}`}
                  >
                    <X className="w-4 h-4" />
                  </button>
                </div>
              )}
            </div>
          </div>
        ))
      )}
    </div>
  </div>
);
